export default "__VITE_ASSET__BfiUBeee__"